<div class=e174_23>

  <div class=e174_24 (click)="emit('1')">
    <div  class="e174_25"></div>
    <span  class="e174_26">1</span>
  </div>

  <div class=e174_27 (click)="emit('4')">
    <div  class="e174_28"></div>
    <span  class="e174_29">4</span>
  </div>

  <div class=e174_30 (click)="emit('7')">
    <div  class="e174_31"></div>
    <span  class="e174_32">7</span>
  </div>

  <div class=e174_33 (click)="emit('0')">
    <div  class="e174_34"></div>
    <span  class="e174_35">0</span>
  </div>

  <div class=e174_36 (click)="emit('2')">
    <div  class="e174_37"></div>
    <span  class="e174_38">2</span>
  </div>

  <div class=e174_39 (click)="emit('5')">
    <div  class="e174_40"></div>
    <span  class="e174_41">5</span>
  </div>

  <div class=e174_42 (click)="emit('8')">
    <div  class="e174_43"></div>
    <span  class="e174_44">8</span>
  </div>

  <div class=e174_45 (click)="emit('3')">
    <div  class="e174_46"></div>
    <span  class="e174_47">3</span>
  </div>

  <div class=e174_48 (click)="emit('6')">
    <div  class="e174_49"></div>
    <span  class="e174_50">6</span>
  </div>

  <div class=e174_51 (click)="emit('9')">
    <div  class="e174_52"></div>
    <span  class="e174_53">9</span>
  </div>

  <div class=e174_54 (click)="emit('DELETE')" >
    <div class=e174_55>
      <div  class="e174_56"></div>
      <span  class="e174_57">DELETE</span>
    </div>
    <!--
    <div class=e174_58>
      <div class=ei174_58_59_1013>
        <div  class="ei174_58_59_1014">

        </div>
        <div  class="ei174_58_59_1015">

        </div>
      </div>
    </div>
    -->
  </div>
</div>
